import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/_hasObjectTag.js
// module id = 819
// module chunks = 115